import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';


function DeviceMenus() {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(''); 

  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/api/devicemenus`);
        if (response != null) {
          setMenus(response.data);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMenus();
  }, []);

  const handleStatusChange = (slno, newStatus) => {
    setMenus(prevMenus => 
      prevMenus.map(menu => 
        menu.slno === slno ? { ...menu, status: newStatus } : menu
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const statusUpdates = {};
    menus.forEach(menu => {
      statusUpdates[menu.slno] = menu.status;
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/devicemenus/update`,
        statusUpdates,
        { withCredentials: true }
      );
      if (response.data.message) {
        setMessage(response.data.message);
      }

      if (response.status !== 200) {
        throw new Error('Update failed');
      }

      
    } catch (err) {
      
      console.error('Update error:', err);
    }
  };

  if (loading) return <div align="center"><CircularProgress/></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div align="center">
      <br></br>
      <form onSubmit={handleSubmit}>
        <table align="center" border="1">
          <thead>
            <tr className="tableheader">
              <th align="center" colSpan="4">ePos Device Menus</th>
            </tr>
            <tr className="tableheader">
              <th>Sl.No</th>
              <th>Service Link</th>
              <th>Description</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {menus.map(menu => (
              <tr 
                key={menu.slno} 
                style={{ backgroundColor: menu.status === 'Y' ? '#b3ffcc' : '#ffe6e6' }}
              >
                <td>{menu.slno}</td>
                <td>{menu.serviceName}</td>
                <td>{menu.menuName}</td>
                <td>
                  <select 
                    value={menu.status} 
                    onChange={(e) => handleStatusChange(menu.slno, e.target.value)}
                  >
                    <option value="Y">Active</option>
                    <option value="N">Stopped</option>
                  </select>
                </td>
              </tr>
            ))}
            <tr align="center">
              <td colSpan={4}><button type="submit" className="button button2">Submit</button></td>
            </tr>
          </tbody>
        </table>
      </form>
       <div  align="center"><p>{message}</p></div>
      <br></br>
            <br></br>
      <br></br>
      <br></br>
      <br></br>


      
    </div>
  );
}

export default DeviceMenus;